<template>
    <span class="sort-column">
      <span class="sort-column__label" v-html="label"/>
      <span class="common-table__sort-arrow"
            :class="{
              'common-table__sort-arrow_asc': isDesc,
              'common-table__sort-arrow_desc': isAsc,
              'sort-column_center': alignCenter
            }"></span>
    </span>
</template>

<script>
  /**
   * table header with sort icon
   */
  export default {
  name: 'BaseTableSortableColumn',
  /*
    * Should be present
    * sortConfig if using multiple sorting
    * sortDirection and sortColumn if using single column sorting
    * */
  props: {
    label: {
      type: String,
      required: true
    },
    alignCenter: {
      type: Boolean,
      default: false
    },
    propName: {
      type: String,
      required: true
    },
    /*
      * [
      *   {
      *     propertyName: String,
      *     sortDirection: 'asc' | 'desc'
      *   }
      * ]
      * */
    sortConfig: {
      type: Array
    },
    sortDirection: String,
    sortColumn: String
  },
  computed: {
    thisColumnInConfig () {
      if (this.sortConfig) {
        return this.sortConfig.find(config => config.propertyName === this.propName)
      }
    },
    isAsc () {
      if (this.thisColumnInConfig) {
        return this.thisColumnInConfig && this.thisColumnInConfig.sortDirection === 'asc'
      }
      return this.sortColumn === this.propName && this.sortDirection === 'asc'
    },
    isDesc () {
      if (this.thisColumnInConfig) {
        return this.thisColumnInConfig && this.thisColumnInConfig.sortDirection === 'desc'
      }
      return this.sortColumn === this.propName && this.sortDirection === 'desc'
    }
  }
}
</script>

<style lang="scss" scoped>
  span {
    user-select: none;
  }

  .sort-column {
    display: flex;
    align-items: center;

    &__label {
      max-width: 78%;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

</style>
